import { render, staticRenderFns } from "./TokensPriceScrollableTable.vue?vue&type=template&id=4f4d673c&scoped=true"
import script from "./TokensPriceScrollableTable.vue?vue&type=script&lang=ts"
export * from "./TokensPriceScrollableTable.vue?vue&type=script&lang=ts"
import style0 from "./TokensPriceScrollableTable.vue?vue&type=style&index=0&id=4f4d673c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4d673c",
  null
  
)

export default component.exports